import { useEffect } from 'react';
import { useCurrentUserPublicProfile } from './PublicProfile/useUserPublicProfile';
import { FirebaseAnalyticsOperation } from '@framework/firebase/analytics';
import * as Sentry from '@sentry/react';

export const UserMetadata: React.FC = () => {
  const profile = useCurrentUserPublicProfile();

  useEffect(() => {
    if (profile) {
      Sentry.setUser({
        id: profile.id,
        username: profile.name,
      });

      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('error-report')) {
        console.error('エラーレポートのテストです');
      }
    } else {
      Sentry.setUser(null);
    }
  }, [profile]);

  useEffect(() => {
    FirebaseAnalyticsOperation.setUserId(profile?.id || '');
  }, [profile]);

  return <></>;
};
